/**
 * --------------
 * mpro namespace
 * --------------
 */

// Import mpro modules
import './modules/mpro.dialog.js'; // <-- must be the first included here, to be able to override other handlers
import './modules/mpro.action-handlers.js';
import './modules/mpro.data-events.js';
import './modules/mpro.form-events.js';
import './modules/mpro.langvar.js';
import './modules/mpro.util.js';
import './modules/mpro.eval.js';
import './modules/mpro.env.js';
import './modules/mpro.loader.js';
import './modules/mpro.cookies.js';
import './modules/mpro.visitor.js';
import './modules/mpro.sections.js';
import './modules/mpro.forms.js';
import './modules/mpro.project-overrides.js';
import './modules/mpro.ajax.js';
import './modules/mpro.shop.js';
// import './modules/mpro.string-util.js';
import './modules/mpro.ui.js';
import './modules/mpro.alert.js';
import './modules/mpro.toast.js';
import './modules/mpro.form-errors.js';
import './modules/mpro.modal.js';
import './modules/mpro.drawer.js';
import './modules/mpro.overlay.js';
import './modules/mpro.overlay-highlight.js';
// import './modules/mpro.remote-action.js';
import './modules/mpro.tooltip.js';
import './modules/mpro.popover.js';
import './modules/mpro.filters.js';
import './modules/mpro.plugins.js';

// Import dynamic modules (lazy loaded modules)
import './modules/mpro.dynamic.js';

// Custom js api
import './modules/mpro.custom-api.js';

// Import the mpro initializer
import './ready.js';

// Export mpro namespace
export default mpro;
